import { defineStore } from 'pinia';

import { Network } from '@eaphone/network/next.ts';

function getCount() {
  return Network.custom
    .get('common/v1/user/message/type/all/unreadCount')
    .then((data) => ({ count: data }));
}

export const useMessageStore = defineStore('message', {
  state: () => ({
    count: 0,
  }),
  actions: {
    fetchData() {
      return getCount().then(({ count }) => {
        this.count = count;
      });
    },
  },
});
